import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Risparmia il {{percentageAmount}}% sugli articoli selezionati',
    description:
      "Risparmia il {{percentageAmount}}% sul tuo ordine con gli articoli selezionati. L'offerta è valida{{fromTo}} fino al raggiungimento del limite massimo delle promozioni, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% di sconto da {{minSpendValue}}',
    description:
      "Risparmia il {{percentageAmount}}% sul tuo ordine. L'offerta è valida{{fromTo}} fino al raggiungimento del limite massimo delle promozioni, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Risparmia {{amount}} sugli articoli selezionati',
    description:
      "Risparmia {{amount}} con gli articoli selezionati. L'offerta è valida{{fromTo}} fino al raggiungimento del limite massimo delle promozioni, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Risparmia {{amount}} da {{minSpendValue}}',
    description:
      "Risparmia {{amount}} sul valore dell'ordine. L'offerta è valida{{fromTo}} fino al raggiungimento del limite massimo delle promozioni, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.Bogo]: {
    title: '2 al prezzo di 1!',
    description:
      "Acquista un articolo e ottieni il secondo gratis. L'offerta è valida{{fromTo}} fino al raggiungimento del limite promozionale, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: '2° articolo a metà prezzo!',
    description:
      "Acquista un articolo e ottieni il secondo a metà prezzo. L'offerta è valida{{fromTo}} fino al raggiungimento del limite promozionale, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Articolo gratuito con importo minimo',
    description:
      "Ricevi un articolo gratuito quando soddisfi le condizioni dell'offerta. L'offerta è valida{{fromTo}} fino al raggiungimento del limite promozionale, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
    reward_items_description: 'Scegli il tuo articolo gratuito.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Articolo gratuito con il tuo ordine',
    description:
      "Ricevi un articolo gratuito quando soddisfi le condizioni dell'offerta. L'offerta è valida{{fromTo}} fino al raggiungimento del limite promozionale, a seconda di quale si verifica prima. Non combinabile con altre promozioni.",
    qualifying_items_description:
      "Seleziona gli articoli che il cliente deve ordinare per ottenere l'articolo gratuito.",
    reward_items_description: 'Scegli il tuo articolo gratuito.',
  },
};

export default {
  offers,
  from_to: ' da {{startsAt}} a {{endsAt}} o',
  qualifying_items_title: 'Articoli idonei',
  reward_items_title: 'Articoli gratuiti',
  buttons: {
    add: 'Aggiungi al carrello',
  },
};
